import { EnumType } from "./enumType";

export type Lang = "en" | "ar";

export const LANG: EnumType<Lang> = {
  ar: "ar",
  en: "en",
};

export const LANG_KEY = "lang";
